/* Healthy Mithai - XB Announcement Bar color fix */
(function () {
  const BG = '#f6dcd4';
  const TEXT = '#103141';
  const OFFER_RE = /Buy Any (?:2|3) Products\s*&\s*Get\s*(?:250|500) ML Gir Cow Ghee Free/i;

  function paintBar() {
    const all = document.querySelectorAll('body *');
    for (const el of all) {
      const txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!OFFER_RE.test(txt) || el.children.length > 8) continue;

      let node = el;
      for (let level = 0; level < 7 && node && node !== document.body; level++, node = node.parentElement) {
        const r = node.getBoundingClientRect();
        const cs = getComputedStyle(node);
        const bg = cs.backgroundColor;
        const blackBg = bg === 'rgb(0, 0, 0)' || bg === 'rgba(0, 0, 0, 0)' && false;
        if (r.width > window.innerWidth * 0.55 && r.height > 20 && r.height < 140) {
          if (blackBg || level >= 1) {
            node.style.setProperty('background-color', BG, 'important');
            node.style.setProperty('background', BG, 'important');
            node.style.setProperty('color', TEXT, 'important');
            node.querySelectorAll('*').forEach(child => {
              child.style.setProperty('color', TEXT, 'important');
              child.style.setProperty('background-color', 'transparent', 'important');
              child.style.setProperty('background-image', 'none', 'important');
            });
            return;
          }
        }
      }
    }
  }



  function positionOfferBar() {
    const all = document.querySelectorAll('body *');
    let candidate = null;
    let candidateArea = 0;
    for (const el of all) {
      const txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!OFFER_RE.test(txt)) continue;
      let node = el;
      for (let level = 0; level < 8 && node && node !== document.body; level++, node = node.parentElement) {
        const r = node.getBoundingClientRect();
        if (r.width >= window.innerWidth * 0.55 && r.height >= 28 && r.height <= 140) {
          const area = r.width * r.height;
          if (area > candidateArea) {
            candidate = node;
            candidateArea = area;
          }
        }
      }
    }
    if (!candidate) return;

    /* The offer must scroll normally with the page, never stay frozen. */
    candidate.style.setProperty('position', 'static', 'important');
    candidate.style.setProperty('top', 'auto', 'important');
    candidate.style.setProperty('left', 'auto', 'important');
    candidate.style.setProperty('right', 'auto', 'important');
    candidate.style.setProperty('width', '100%', 'important');
    candidate.style.setProperty('height', window.innerWidth <= 990 ? '50px' : '56px', 'important');
    candidate.style.setProperty('min-height', window.innerWidth <= 990 ? '50px' : '56px', 'important');
    candidate.style.setProperty('z-index', '20', 'important');
    candidate.style.setProperty('overflow', 'hidden', 'important');
    candidate.style.setProperty('margin', '0', 'important');
    candidate.style.setProperty('transform', 'none', 'important');

    /* Move the detected offer section directly before our custom header so the
       visual order is always: Offer marquee -> Header -> Homepage content. */
    const header = document.querySelector('.custom-header');
    if (header && candidate !== header && !header.contains(candidate)) {
      const headerSection = header.closest('.shopify-section');
      if (headerSection && candidate.parentElement !== headerSection.parentElement) {
        headerSection.parentElement.insertBefore(candidate, headerSection);
      } else if (headerSection && candidate.nextElementSibling !== headerSection) {
        headerSection.parentElement.insertBefore(candidate, headerSection);
      }
    }
  }

  function run() { paintBar(); positionOfferBar(); setTimeout(() => { paintBar(); positionOfferBar(); }, 250); setTimeout(() => { paintBar(); positionOfferBar(); }, 1000); setTimeout(() => { paintBar(); positionOfferBar(); }, 2500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(() => { paintBar(); positionOfferBar(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
